/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { FilterLogic } from '../filterLogic.schema';
import { IFilterBase } from '../iFilterBase.schema';

export const GetAllConcernsIssueTypesParams = zod.object({
  "payload.Logic": zod.lazy(() => FilterLogic).optional(),
  "payload.Filters": zod.array(zod.lazy(() => IFilterBase)).optional()
})

export type GetAllConcernsIssueTypesParams = zod.input<typeof GetAllConcernsIssueTypesParams>;
export type GetAllConcernsIssueTypesParamsOutput = zod.output<typeof GetAllConcernsIssueTypesParams>;
